import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Projects = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Active Campaigns</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Active Campaigns</li>
          </ul>
        </div>
      </section>

      <section className="ul-projects ul-section-spacing">
        <div className="ul-container">
          <div className="row ul-bs-row justify-content-center">
            <div className="col-lg-8 col-md-6 col-10 col-xxs-12">
              <div className="ul-project">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <Link to="/project-details?campaign=asthma-management"
                        >Asthma Management for NYC Families</Link
                      >
                    </h3>
                    <p className="ul-project-descr">
                      Central Asian community-focused asthma education and
                      clinic connections
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=asthma-management"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-10 col-xxs-12">
              <div className="ul-project ul-project--sm">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <a to="/project-details?campaign=mental-health"
                        >Mental Health Resources - Multilingual Support</a
                      >
                    </h3>
                    <p className="ul-project-descr">
                      Bilingual mental health explainers reaching 1,200+
                      community members
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=mental-health"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-10 col-xxs-12">
              <div className="ul-project ul-project--sm">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/group-of-diversity-people-volunteen-arm-around-2025-02-10-01-27-31-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <a to="/project-details?campaign=student-mentorship"
                        >Student Mentorship Program - Healthcare Career
                        Pathways</a
                      >
                    </h3>
                    <p className="ul-project-descr">
                      87+ students mentored with real-world healthcare guidance
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=student-mentorship"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-6 col-10 col-xxs-12">
              <div className="ul-project">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/happy-volunteers-putting-hands-together-wearing-gl-2025-10-05-19-19-30-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <a to="/project-details?campaign=clinic-directory"
                        >NYC Clinic Directory - Uzbek/Russian/Tajik Languages</a
                      >
                    </h3>
                    <p className="ul-project-descr">
                      Interactive maps connecting 162+ verified clinics to
                      Central Asian communities
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=clinic-directory"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-6 col-10 col-xxs-12">
              <div className="ul-project">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <a to="/project-details?campaign=hypertension"
                        >Hypertension Management Guide - O'zbek/Russian</a
                      >
                    </h3>
                    <p className="ul-project-descr">
                      Visual guides and clinic resource maps for blood pressure
                      management
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=hypertension"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-10 col-xxs-12">
              <div className="ul-project ul-project--sm">
                <div className="ul-project-img">
                  <img
                    src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg"
                    alt="Project Image"
                  />
                </div>
                <div className="ul-project-txt">
                  <div>
                    <h3 className="ul-project-title">
                      <a to="/project-details?campaign=diabetes-education"
                        >Diabetes Education for Uzbek & Central Asian
                        Families</a
                      >
                    </h3>
                    <p className="ul-project-descr">
                      Bilingual health literacy campaign reaching 2,100+
                      families
                    </p>
                  </div>
                  <Link
                    to="/project-details?campaign=diabetes-education"
                    className="ul-project-btn"
                    ><i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Projects;
